import { commonColumns } from 'common/list-configs/common-list.config';
import { SecurityTypeEnum } from 'common/enums/security-type.enum';

const { email, phone } = commonColumns();

export const accountsTableInitialColumns = [
  {
    key: 'firstName',
    title: 'First name',
    dataKey: 'firstName',
    width: 200,
    minWidth: 150,
    resizable: true,
    sortable: true,
    flexGrow: 1,
  },
  {
    key: 'lastName',
    title: 'Last name',
    dataKey: 'lastName',
    width: 200,
    minWidth: 150,
    resizable: true,
    sortable: true,
    flexGrow: 1,
  },
  email,
  {
    key: 'accountName',
    title: 'Account name',
    dataKey: 'accountName',
    width: 200,
    minWidth: 150,
    resizable: true,
    sortable: true,
    flexGrow: 1,
  },
  phone,
  {
    key: 'defaultGate',
    title: 'Default gate',
    dataKey: 'defaultGate',
    width: 200,
    minWidth: 150,
    resizable: true,
    sortable: true,
    flexGrow: 1,
  },
  {
    key: 'securityType',
    title: 'Security type',
    dataKey: 'securityType',
    width: 150,
    minWidth: 120,
    resizable: true,
    sortable: true,
    flexGrow: 1,
    cellRenderer: ({ cellData }: { cellData: SecurityTypeEnum }) => {
      if (cellData === SecurityTypeEnum.OnSite) return 'OnSite';
      if (cellData === SecurityTypeEnum.Virtual) return 'Virtual';
      return '';
    },
  },
];
